import React, { memo } from 'react';

import { formatNumber } from '../helpers/utils';

export default memo(function BoxChartTop(props) {
    const { onIndexClick } = props;
    //
    return (
        <div className="boxchart__top flex__center" style={{gap: 4}}>
            <div className="boxchart__top--name " onClick={(event) => onIndexClick && onIndexClick(event, props.name)} style={{overflow: 'hidden', textOverflow: 'ellipsis', cursor: 'pointer'}}>{props.name}</div>
            <div className="flex__center">
                <span className={" " + props.change_color} style={{whiteSpace: 'nowrap'}}><span className=''>{formatNumber(props.current_index)}</span> ({props.change_index} / {props.pct_change_index}%)</span>
            </div>
        </div>
    )
});